import { Routes } from '@angular/router';
import { DataWarehouseDashboardComponent } from './components/data-warehouse-dashboard/data-warehouse-dashboard.component';
import { DataWarehouseWorkspaceComponent } from './components/data-warehouse-workspace/data-warehouse-workspace.component';

export const routes: Routes = [
  {
    path: 'datawarehouse',
    component: DataWarehouseDashboardComponent,
    data: {
      title: 'Data Entry',
      isNav:  true,
      icon: 'web',
      permissions: ['DataWarehouseModule.DataEntry:Access'],
    },
  },
  {
    path: 'datawarehouse-workspace/:submittingEntityKey/:entityKey/:key',
    component: DataWarehouseWorkspaceComponent,
    data: {
      permissions: ['DataWarehouseModule.Entities:View'],
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/datawarehouse/routes.config.ts